<template>
  <div class="receipt-info">
    <el-dialog
      title="上传银行回单"
      width="540px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="formEl"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="上传图片：" prop="bankReceiptUrl">
          <Upfile accept=".JPG, .jpg, .png, .PNG, .jpeg, .JPEG, .pdf" v-model="form.bankReceiptUrl" />
          <p class="form-tips">支持扩展名: .png .jpeg .jpg .pdf 文件大小2M以内</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button :loading="saveing" size="small" type="primary" @click="handleAffirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  updateBankReceipt
} from "@/api/orderAdmin/orderList"
import Upfile from '@/components/upload/file'
import { processing } from '@/utils/handle.js'

export default {
  name: 'ReceiptInfo',

  components: { Upfile, },
  data () {
    return {
      dialogVisible: false,
      form: {
        bankReceiptUrl: ''
      },
      rules: {
        bankReceiptUrl: [
          { required: true, message: "请上传图片!", trigger: "blur" },
        ],
      },
      saveing: false
    }
  },
  methods: {
    init (payload) {
      this.form.id = payload.id
      if (payload.bankReceiptUrl) {
        this.form.bankReceiptUrl = payload.bankReceiptUrl
      }
      this.dialogVisible = ''
    },
    handleAffirm () {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          this.saveing = true
          const params = {
            ...this.form
          }
          updateBankReceipt(processing(params)).then(({ code }) => {
            if (code === 0) {
              this.$message.success('上传银行回单成功!')
              this.$emit('refresh')
              this.handleClose()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    handleClose () {
      this.form = this.$options.data().form
      this.$refs.formEl && this.$refs.formEl.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.form-tips {
  font-size: 12px;
  color: #999;
}
</style>
